export { default } from "./RecommendedResources";
